import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Logo } from "@/components/brand/Logo";
import { LayoutDashboard, Car, FileCheck2, KeyRound, User2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PortalLayout = ({ children, tabs, activeTab, onTabChange, kind = "customer" }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const title = kind === "admin" ? "Admin Portal" : "Customer Portal";

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 container-x py-8">
        <div className="grid lg:grid-cols-[280px_1fr] gap-6">
          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="card-clean p-5">
              <div className="flex items-center gap-3">
                <Logo variant="mark" height={32} to={null} />
                <div className="leading-tight min-w-0">
                  <div className="font-display font-semibold truncate">{user?.full_name || "Guest"}</div>
                  <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
                </div>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <span className={`text-[10px] uppercase tracking-widest rounded-full px-2 py-0.5 ${kind === "admin" ? "bg-[hsl(var(--charcoal-950))] text-white" : "badge-blue"}`}>{title}</span>
                {kind === "customer" && user?.is_member && (
                  <span className="text-[10px] uppercase tracking-widest rounded-full px-2 py-0.5 badge-blue">Club Member</span>
                )}
              </div>
              <nav className="mt-5 flex flex-col gap-1" data-testid="portal-nav">
                {tabs.map((t) => (
                  <button
                    key={t.key}
                    onClick={() => onTabChange(t.key)}
                    className={`text-left flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors duration-150 ${activeTab === t.key ? "bg-[hsl(var(--blue-100))] font-medium" : "hover:bg-secondary text-muted-foreground"}`}
                    data-testid={`portal-tab-${t.key}`}
                  >
                    {t.icon && <t.icon className="h-4 w-4" />}
                    {t.label}
                  </button>
                ))}
              </nav>
              <div className="mt-5 pt-4 border-t border-border flex flex-col gap-2">
                <Button variant="outline" className="rounded-xl" asChild><Link to="/">Back to site</Link></Button>
                <Button variant="ghost" className="rounded-xl" onClick={() => { logout(); nav("/"); }}><LogOut className="h-4 w-4 mr-1" /> Sign out</Button>
              </div>
            </div>
          </aside>
          <section>{children}</section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const CustomerTabIcons = { LayoutDashboard, Car, FileCheck2, KeyRound, User2 };
